import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import CENBlogSearchQueryState from "@tCentro/Store/Reducer/CENBlogSearchQueryState";

import { Draft } from "immer";
 
const initialState: CENBlogSearchQueryState = {
    searchQuery:"" ,
};
export default createTypedReducerWithImmer(initialState, {
    "Custom/Article/SetBlogSearchQuery": (
        draft: Draft<CENBlogSearchQueryState>,
        action: { searchQuery: any },
    ) => {
        draft.searchQuery = action.searchQuery;
    },
});